import { useEffect, useCallback } from "react";

import {
    useFastshiftAnalyticsData,
    useFireAnalyticsEvents
} from "@/components/fastshift/analytics";
import {
    ActionKey,
    ActionSubjectIdKey,
    ActionSubjectKey,
    SourceKey
} from "@/components/fastshift/analytics/constants";

export const useCriticalErrorDisplayAnalytics = () => {
    const { identityAttrs } = useFastshiftAnalyticsData();
    const { fireScreenEvent, fireUIEvent } =
        useFireAnalyticsEvents(identityAttrs);

    // Screen Event
    useEffect(() => {
        fireScreenEvent({
            name: SourceKey.FASTSHIFT_PORTAL_CRITICAL_ERROR_SCREEN
        });
    }, [fireScreenEvent]);

    // UI event
    const refreshPortalButtonClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.BUTTON,
            actionSubjectId: ActionSubjectIdKey.REFRESH_PORTAL_BUTTON,
            source: SourceKey.FASTSHIFT_PORTAL_CRITICAL_ERROR_SCREEN
        });
    }, [fireUIEvent]);

    return { refreshPortalButtonClickUIEvent };
};
